module.exports = "query GetCollection($id: ID!) {\n  collection(id: $id) {\n    ...CollectionFragment\n  }\n}\n"